import { useState } from 'react';

export default function ManageSubscription() {
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const apiUrl = import.meta.env.VITE_API_URL || '';
            const res = await fetch(`${apiUrl}/api/create-portal-session`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email }),
            });

            if (!res.ok) {
                const data = await res.json();
                throw new Error(data.error || 'Something went wrong');
            }

            const { url } = await res.json();
            window.location.href = url;
        } catch (err: unknown) {
            setError(err instanceof Error ? err.message : 'Failed to open customer portal');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px',
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
        }}>
            <div style={{
                maxWidth: '440px',
                width: '100%',
                background: 'white',
                borderRadius: '16px',
                padding: '40px',
                boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)'
            }}>
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <div style={{
                        width: '64px',
                        height: '64px',
                        borderRadius: '16px',
                        background: 'linear-gradient(135deg, #10B981, #1E3A8A)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 20px',
                        fontSize: '28px'
                    }}>
                        ⚙️
                    </div>
                    <h1 style={{
                        fontSize: '24px',
                        fontWeight: 700,
                        color: '#0f172a',
                        margin: '0 0 8px'
                    }}>
                        Manage Subscription
                    </h1>
                    <p style={{
                        fontSize: '15px',
                        color: '#64748b',
                        margin: 0,
                        lineHeight: 1.5
                    }}>
                        Enter your email to manage your plan, update payment details, or cancel your subscription.
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    <label style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#334155',
                        marginBottom: '8px'
                    }}>
                        Email Address
                    </label>
                    <input
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="your@email.com"
                        style={{
                            width: '100%',
                            padding: '12px 16px',
                            borderRadius: '8px',
                            border: '1px solid #e2e8f0',
                            fontSize: '15px',
                            outline: 'none',
                            transition: 'border-color 0.2s',
                            boxSizing: 'border-box',
                            color: '#0f172a'
                        }}
                        onFocus={(e) => e.target.style.borderColor = '#10B981'}
                        onBlur={(e) => e.target.style.borderColor = '#e2e8f0'}
                    />

                    {error && (
                        <p style={{
                            color: '#ef4444',
                            fontSize: '14px',
                            margin: '12px 0 0',
                            padding: '8px 12px',
                            background: '#fef2f2',
                            borderRadius: '6px'
                        }}>
                            {error}
                        </p>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            width: '100%',
                            marginTop: '20px',
                            padding: '14px',
                            borderRadius: '8px',
                            border: 'none',
                            background: loading ? '#94a3b8' : 'linear-gradient(135deg, #10B981, #1E3A8A)',
                            color: 'white',
                            fontSize: '16px',
                            fontWeight: 600,
                            cursor: loading ? 'not-allowed' : 'pointer',
                            transition: 'opacity 0.2s'
                        }}
                    >
                        {loading ? 'Loading...' : 'Open Customer Portal →'}
                    </button>
                </form>

                <p style={{
                    textAlign: 'center',
                    marginTop: '24px',
                    fontSize: '13px',
                    color: '#94a3b8'
                }}>
                    Powered by <a href="https://stripe.com" target="_blank" rel="noopener noreferrer" style={{ color: '#10B981', textDecoration: 'none' }}>Stripe</a>
                </p>
            </div>
        </div>
    );
}
